export const SAVE_USER_INFO = 'SAVE_USER_INFO';
